import { IFormValidation } from '@aston/foundation';

export class INewFederationUserValidator implements IFormValidation {
	ruleset = 'createFederationUserCommandValidator';
	fields = {
		Mail: 'Mail',
	};
}

export const NewFederationUserValidator = new INewFederationUserValidator();
